import React from 'react';
import { BrandColor } from '@styleseat/brand';
import { Box, Inline } from '@styleseat/ui';
import {
  BodyText,
  Button,
  Stack,
  TextFormField,
  DeprecatedMaskedFormField,
} from '../../../../../ui';
import { EmailChangeEvent } from '../contants';

type SignupStateProps = {
  emailErrorMessage: string;
  emailValue: string;
  onChangeEmail: (event: EmailChangeEvent) => void;
  onEmailFocus: () => void;
  onKeyPress: (e) => void;
  passwordErrorMessage: any;
  passwordValue: string;
  onChangePassword: (newValue: string) => void;
  onPasswordFocus: () => void;
  firstNameErrorMessage: any;
  firstNameValue: string;
  onChangeFirstName: (newValue: string) => void;
  onFirstNameFocus: () => void;
  lastNameErrorMessage: any;
  lastNameValue: string;
  onChangeLastName: (newValue: string) => void;
  onLastNameFocus: () => void;
  phoneNumberErrorMessage: any;
  phoneNumberValue: string;
  onChangePhoneNumber: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPhoneNumberFocus: () => void;
  isLoading: boolean;
  onClickSignup: () => void;
  isSignupDisabled: boolean;
  onOpenTOS: () => void;
  onOpenPrivacyPolicy: () => void;
};

export const SignupState: React.FCWithChildren<SignupStateProps> = ({
  emailErrorMessage,
  emailValue,
  onChangeEmail,
  onEmailFocus,
  onKeyPress,
  passwordErrorMessage,
  passwordValue,
  onChangePassword,
  onPasswordFocus,
  firstNameErrorMessage,
  firstNameValue,
  onChangeFirstName,
  onFirstNameFocus,
  lastNameErrorMessage,
  lastNameValue,
  onChangeLastName,
  onLastNameFocus,
  phoneNumberErrorMessage,
  phoneNumberValue,
  onChangePhoneNumber,
  onPhoneNumberFocus,
  isLoading,
  onClickSignup,
  isSignupDisabled,
  onOpenTOS,
  onOpenPrivacyPolicy,
}) => {
  const handleChangeEmail = newValue => onChangeEmail({ newValue });

  return (
    <Stack space={16}>
      <TextFormField
        accentColor={BrandColor.Red}
        name="email"
        id="email"
        autoComplete="email"
        borderColor={BrandColor.Silver}
        style={{
          borderRadius: 4,
        }}
        message={emailErrorMessage}
        label="Email"
        aria-label="Email"
        type="email"
        value={emailValue}
        onChangeText={handleChangeEmail}
        onFocus={onEmailFocus}
        onKeyPress={onKeyPress}
        testID="booking-sign-in-and-up-email-text-field"
      />
      <TextFormField
        accentColor={BrandColor.Red}
        message={passwordErrorMessage}
        name="password"
        id="password"
        autoComplete="password"
        borderColor={BrandColor.Silver}
        style={{
          borderRadius: 4,
        }}
        label="Password"
        aria-label="password"
        type="password"
        value={passwordValue}
        onChangeText={onChangePassword}
        onFocus={onPasswordFocus}
        onKeyPress={onKeyPress}
        testID="booking-sign-in-and-up-password-text-field"
      />
      <Inline justifyContent="space-between">
        <Box maxWidth="calc(50% - 4px)">
          <TextFormField
            accentColor={BrandColor.Red}
            message={firstNameErrorMessage?.[0]}
            name="firstName"
            id="firstName"
            autoComplete="name"
            borderColor={BrandColor.Silver}
            style={{
              borderRadius: 4,
            }}
            label="First Name"
            aria-label="first name"
            type="text"
            value={firstNameValue}
            onChangeText={onChangeFirstName}
            onFocus={onFirstNameFocus}
            onKeyPress={onKeyPress}
            testID="booking-sign-in-and-up-first-name-text-field"
          />
        </Box>
        <Box maxWidth="calc(50% - 4px)">
          <TextFormField
            accentColor={BrandColor.Red}
            message={lastNameErrorMessage?.[0]}
            name="lastName"
            id="lastName"
            autoComplete="name"
            borderColor={BrandColor.Silver}
            style={{
              borderRadius: 4,
            }}
            label="Last Name"
            aria-label="last name"
            type="text"
            value={lastNameValue}
            onChangeText={onChangeLastName}
            onFocus={onLastNameFocus}
            onKeyPress={onKeyPress}
            testID="booking-sign-in-and-up-last-name-text-field"
          />
        </Box>
      </Inline>
      <DeprecatedMaskedFormField
        mask="(999) 999-9999"
        accentColor={BrandColor.Red}
        message={phoneNumberErrorMessage?.[0]}
        name="phonenumber"
        id="phonenumber"
        autoComplete="tel"
        borderColor={BrandColor.Silver}
        style={{
          borderRadius: 4,
        }}
        label="Phone number"
        aria-label="phone number"
        type="phone"
        value={phoneNumberValue}
        onValueChange={onChangePhoneNumber}
        onFocus={onPhoneNumberFocus}
        onKeyPress={onKeyPress}
        testID="booking-sign-in-and-up-phone-number-text-field"
      />
      <Box
        alignSelf="center"
        maxWidth={400}
        width="100%"
      >
        <Button
          loading={isLoading}
          appearance="primary-neue"
          size="large"
          onClick={onClickSignup}
          testID="signin-and-signup-signup-button"
          disabled={isSignupDisabled}
        >
          Sign Up
        </Button>
      </Box>
      <Inline justifyContent="center" paddingTop={4}>
        <BodyText appearance="smaller" color={BrandColor.Metal} textAlign="center">
          By signing up I agree to the{'\n'}
          <BodyText appearance="smaller" color={BrandColor.DarkBlue} onPress={onOpenTOS}> terms of
            service
          </BodyText> and
          <BodyText appearance="smaller" color={BrandColor.DarkBlue} onPress={onOpenPrivacyPolicy}> privacy
            policy
          </BodyText>
        </BodyText>
      </Inline>
    </Stack>
  );
};
